import React from 'react';

const EmployeeBulkActionDialog = () => {
    return (
        <div>

        </div>
    );
};

export default EmployeeBulkActionDialog;
